export default {
  OK: "オーケー",
  ok: "オーケー",
  loginFailed: "ログインに失敗しました, もう一度お試しください.",
  requestFailed: "りくえすとに しっぱいしました, いんたーねっと せつぞくを かくにんしてください.",
  invalidLogin: "ユーザー名またはパスワードが無効です.",
  invalidPassword: "ユーザー名またはパスワードが無効です.",
  thisFunctionExists: "この機能はすでに存在します.",
  thisFunctionNotAllowDelete: "この機能は削除できません.",
  thisFunctionNotExists: "この機能は存在しません.",
  targetFunctionIdRequired: "対象機能IDは必須です.",
  thisPageExists: "このページはすでに存在します.",
  thisPageNotAllowDelete: "このページは削除できません.",
  thisRoleExists: "この役割はすでに存在します.",
  thisRoleNotAllowDelete: "この役割は削除できません.",
  targetRoleIdRequired: "対象ロールIDは必須です.",
  invalidParameter: "無効なパラメーター.",
  systemError: "システムがあなたのリクエストを処理できません.",
  spErrorMessage: "SPメッセージエラー（エラーの内容に依存します）.",
  actionbyRequired: "現在のユーザーは必須です.",
  sessionTokenRequired: "セッショントークンは必須です.",
  functionIdRequired: "機能IDは必須です.",
  functionNameRequired: "機能名は必須です.",
  newFunctionNameRequired: "機能名は必須です.",
  pageIdRequired: "ページIDは必須です.",
  newPageIdRequired: "ページIDは必須です.",
  newPageNameRequired: "ページ名は必須です.",
  targetPageIdRequired: "対象ページIDは必須です.",
  userIdRequired: "ユーザーIDは必須です.",
  passwordRequired: "パスワードは必須です.",
  userNameRequired: "フルネームは必須です.",
  passwordValidation: "パスワードは6〜20文字で、数字と文字の組み合わせである必要があります.",
  pageNumRequired: "ページ番号は必須です.",
  pageSizeRequired: "ページサイズは必須です.",
  roleIdRequired: "ロールIDは必須です",
  oldPasswordRequired: "現在のパスワードは必須です.",
  userStatusRequired: "ユーザーのステータスは必須です.",
  newRoleIdRequired: "ロールIDは必須です.",
  newRoleNameRequired: "ロール名は必須です.",
  startDateRequired: "開始日（開始日）は必須です.",
  endDateRequired: "終了日（終了日）は必須です.",
  startDateIsGteEndDate: "開始日が終了日より後になっています.",
  sportsTypeRequired: "スポーツタイプは必須です.",
  teamTypeRequired: "チームタイプは必須です.",
  thisRoleNotExists: "このロールは存在しません.",
  thisPageNotExists: "このページは存在しません.",
  thisUserExists: "このユーザーはすでに存在します.",
  thisUserNotExists: "このユーザーは存在しません.",
  thisUserBlackListed: "あなたのアカウントは停止されました.",
  thisUserInactive: "あなたのアカウントは無効化されました.",
  thisUserBlocked: "あなたのアカウントはブロックされました.",
  thisUserNotActive: "あなたのアカウントは無効になりました.",
  InvalidPageFunction:"無効なページ機能.",
  invalidUser: "無効なユーザーです!",
  invalidToken: "無効なセッション!",
  NoUserAccessRight: "アクセスが拒否されました!",
  unableSPProcess: "システムがあなたのリクエストを処理できません.",
  connection: "接続エラー",

  isRequired: "{fname} を入力してください.",
  isMinValue: "{fname} は最低でも {fvalue} が必要です.",
  isMaxValue: "{fname} は {fvalue} 以下でなければなりません.",
  isMinLength: "{fname} は少なくとも {fvalue} 文字が必要です.",
  isMaxLength: "{fname} は {fvalue} 文字以下でなければなりません.",
  isAlpha: "{fname} はアルファベットのみを受け付けます.",
  isAlphaNum: "{fname} は英数字のみを受け付けます.",
  isNumeric: "{fname} は数字のみを受け付けます.",
  isSingleDecimal: "{fname} は小数点以下1桁までの数字のみを受け付けます.",
  isInteger: "{fname} は整数のみを受け付けます.",
  isEmail: "{fname} は有効なメールアドレスのみを受け付けます.",
  isIpAddress: "{fname} は有効なIPv4アドレスのみを受け付けます.",
  isSameAs: "{fname} は {fname2} と同じでなければなりません.",
  isUrl: "{fname} はURLのみを受け付けます.",
  containAlphaNum: "{fname} には少なくとも1つのアルファベットと1つの数字が必要です.",
  selectOption: "{fname} を選択してください.",
  notSameAs: "{fname} と {fname2} は同じではいけません.",
  isBetween: "{fname} は {min} 以上 {max} 以下でなければなりません.",
  isSSFormat: "無効なスーパシニアアカウントID形式です.",
  isReserved: "予約済みのアカウントID.",
  isExisted: "アカウントIDが存在しています.",
  onlySmallCapsAlphaNum: "小文字のアルファベット（a〜z）と数字（0〜9）のみが使用できます",
  noJavaScriptInjection: "{fname} に無効または有害な文字が含まれています.",

  system_error: "システムがリクエストを処理できません.",
  invalid_password: "ユーザー名またはパスワードが無効です.",
  block: "あなたのアカウントはブロックされています.",
  invalid_security_code: "無効なセキュリティコード.",

  source_account_id_required: "アカウントIDが必要です.",
  target_account_id_required: "対象のアカウントIDが必要です.",
  permission_denied: "許可がありません.",
  account_id_required: "アカウントIDが必要です.",
  sub_login_id_required: "ログインIDが必要です.",
  account_not_exists: "アカウントは存在しません.",
  profile_not_exists: "プロフィールは存在しません.",
  account_inactive: "非アクティブなアカウント.",
  not_blocked_account: "有効なアカウント.",
  password_required: "パスワードが必要です.",
  parent_id_required: "親IDが必要です.",
  parent_not_exists:"親IDは存在しません.",
  invalid_account_type: "無効なアカウントタイプ.",
  account_exists: "アカウントはすでに存在します.",
  login_id_required: "ログインIDが必要です.",
  new_login_id_required: "新しいログインIDが必要です.",
  login_id_not_exists: "ログインIDは存在しません.",
  invalid_authority_role: "無効な役割.",
  profile_inactive: "無効なプロフィール.",
  secondary_account_exists: "セカンダリアカウントはすでに存在します.",
  new_login_id_exists: "新しいログインIDはすでに存在します.",
  new_password_required: "新しいパスワードが必要です.",
  security_tag_required: "セキュリティタグが必要です.",
  security_code_required: "セキュリティコードが必要です.",
  start_date_required: "開始日が必要です.",
  end_date_required: "終了日が必要です.",
  start_date_gt_end_date: "開始日が終了日よりも後の日付です.",
  member_id_required: "メンバーIDが必要です.",
  currency_code_required: "通貨コードが必要です.",
  commission_setting_not_exists: "コミッション設定は存在しません.",
  incomplete_account_line: "不完全なアカウント行.",
  invalid_hdp_package: "無効なHDPパッケージ.",
  search_id_required: "検索IDが必要です.",
  profile_id_required: "プロフィールIDが必要です.",
  login_not_exists: "ログインは存在しません.",
  no_changes: "変更は検出されませんでした.",
  start_date_require: "開始日が必要です.",
  league_id_required: "リーグIDが必要です.",
  sport_type_required: "スポーツタイプが必要です.",
  match_id_required: "マッチIDが必要です.",
  target_login_id_required: "対象のログインIDが必要です.",
  parent_account_not_exists: "親アカウントは存在しません.",
  parent_account_inactive: "非アクティブな親アカウント.",
  parent_profile_not_exists: "親プロフィールは存在しません.",
  parent_profile_inactive: "非アクティブな親プロフィール.",
  target_login_id_not_exists: "対象のログインIDは存在しません.",
  incorrect_parent: "無効な親ID.",
  invalid_session: "無効なセッションリクエスト.",
  session_expired: "セッションが期限切れです.",
  settle_amount_required: "決済額が必要です.",
  invalid_settle_amount: "無効な決済額.",
  settle_amount_gt_yesterday_balance: "決済額が昨日の残高を超えています.",
  invalid_account_status: "無効なアカウントステータス.",
  bet_limit_packages_required: "ベット制限パッケージが必要です.",
  bet_limit_exists: "ベット制限はすでに存在します.",
  member_bet_limit_package_gt_one: "メンバーのベット制限パッケージが複数あります.",
  parent_bet_limit_not_exists: "親のベット制限は存在しません.",
  account_commission_required: "アカウント手数料が必要です.",
  commission_setting_exists: "コミッション設定はすでに存在します.",
  parent_comm_not_exists: "親のコミッション設定は存在しません.",
  exceeded_parent_comm: "親のコミッション設定を超えています.",
  others_commission_required: "他のコミッション設定が必要です.",
  exceeded_parent_1x2: "親の1x2コミッション設定を超えています.",
  exceeded_parent_other: "親のその他のコミッション設定を超えています.",
  hdp_commission_required: "HDPコミッション設定が必要です.",
  exceeded_parent_hdp_a: "親のHPD(A)コミッション設定を超えています.",
  exceeded_parent_hdp_b: "親のHPD(B)コミッション設定を超えています.",
  exceeded_parent_hdp_c: "親のHPD(C)コミッション設定を超えています.",
  exceeded_parent_hdp_d: "親のHPD(D)コミッション設定を超えています.",
  exceeded_parent_hdp_e: "親のHPD(E)コミッション設定を超えています.",
  exceeded_parent_hdp_f: "親のHPD(F)コミッション設定を超えています.",
  exceeded_parent_hdp_g: "親のHPD(G)コミッション設定を超えています.",
  exceeded_parent_hdp_h: "親のHPD(H)コミッション設定を超えています.",
  exceeded_parent_hdp_i: "親のHPD(I)コミッション設定を超えています.",
  exceeded_parent_hdp_j: "親のHPD(J)コミッション設定を超えています.",
  LIVECASINO_upline_pt_required: "[Livecasino] アプラインのPT設定が必要です.",
  LIVECASINO_pt_setting_exists: "[Livecasino] PT設定が必要です.",
  LIVECASINO_parent_pt_not_exists: "[Livecasino] 親のPT設定は存在しません.",
  LIVECASINO_parent_min_not_meet: "[Livecasino] 親の最低PTと一致しません.",
  LIVECASINO_exceeded_parent_pt: "[Livecasino] 親のPT設定を超えています.",
  LIVECASINO_account_pt_required: "[Livecasino] アカウントのPT設定が必要です.",
  LIVECASINO_upline_remaining_required: "【[Livecasino] アプラインの残りPT設定が必要です.",
  LIVECASINO_account_min_required: "[Livecasino] アカウントの最低PT設定が必要です.",
  LIVECASINO_upline_remaining_gt_account_pt: "[Livecasino] アプラインの残りPT設定がアカウントのPT設定よりも高いです.",
  LIVECASINO_account_min_gt_p: "[Livecasino] アカウントの最低PT設定が親のPT設定よりも高いです.",
  SLOTS_upline_pt_required: "[Slots] アップラインPT設定が必要です.",
  SLOTS_pt_setting_exists: "[Slots] PT設定が必要で.",
  SLOTS_parent_pt_not_exists: "[Slots] 親のPT設定が存在しません.",
  SLOTS_parent_min_not_meet: "[Slots] 親の最小PTに一致しません.",
  SLOTS_exceeded_parent_pt: "[Slots] 親のPT設定を超えました.",
  SLOTS_account_pt_required: "[Slots] アカウントPT設定が必要です.",
  SLOTS_upline_remaining_required: "[Slots] アップラインの残りのPT設定が必要です.",
  SLOTS_account_min_required: "[Slots] アカウントの最小PT設定が必要です.",
  SLOTS_upline_remaining_gt_account_pt: "[Slots] アップラインの残りのPT設定がアカウントPT設定より大きいです.",
  SLOTS_account_min_gt_pt: "[Slots] アカウントの最小PT設定が親のPT設定を超えています.",
  bet_type_required: "ベットタイプが必要です",
  schedule_1_to_7_required: "決済スケジュールが必要です",
  schedule_exists: "決済スケジュールは存在しません.",
  parent_schedule_not_exists: "親の決済スケジュールは存在しません.",
  schedule_1_not_available: "月曜日の決済は利用できません.",
  schedule_2_not_available: "火曜日の決済は利用できません.",
  schedule_3_not_available: "水曜日の決済は利用できません.",
  schedule_4_not_available: "木曜日の決済は利用できません.",
  schedule_5_not_available: "金曜日の決済は利用できません.",
  schedule_6_not_available: "土曜日の決済は利用できません.",
  schedule_7_not_available: "日曜日の決済は利用できません.",
  credit_limit_required: "クレジット限度額が必要です.",
  member_credit_limit_required: "メンバーのクレジット限度額が必要です.",
  wallet_exists: "アカウントはすでに存在します.",
  member_credit_limit_gt_credit_limit: "メンバーのクレジット限度額がクレジット限度額を超えています.",
  parent_wallet_not_exists: "アカウントは存在しません.",
  account_credit_limit_gt_parent: "アカウントのクレジット限度額が親のクレジット限度額を超えています.",
  member_credit_limit_gt_parent: "メンバーのクレジット限度額が親のクレジット限度額を超えています.",
  exceeded_credit_limit: "アカウントのクレジット限度額を超えています.",
  soccer_min_bet_required: "最低ベット額が必要です.",
  soccer_max_bet_required: "最大ベット額が必要です.",
  soccer_max_per_match_required: "試合ごとの最大ベット額が必要です",
  soccer_bet_limit_exists: "ベット制限はすでに存在します.",
  soccer_parent_bet_limit_not_exists: "親のベット制限は存在しません.",
  soccer_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  soccer_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  soccer_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  basketball_min_bet_required: "最低ベット額が必要です.",
  basketball_max_bet_required: "最大ベット額が必要です.",
  basketball_max_per_match_required: "試合ごとの最大ベット額が必要です",
  basketball_bet_limit_exists: "ベット制限はすでに存在します.",
  basketball_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  basketball_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  basketball_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  basketball_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  tennis_min_bet_required: "最低ベット額が必要です.",
  tennis_max_bet_required: "最大ベット額が必要です.",
  tennis_max_per_match_required: "試合ごとの最大ベット額が必要ですd",
  tennis_bet_limit_exists: "ベット制限はすでに存在します.",
  tennis_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  tennis_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  tennis_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  tennis_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  baseball_min_bet_required: "最低ベット額が必要です.",
  baseball_max_bet_required: "最大ベット額が必要です.",
  baseball_max_per_match_required: "試合ごとの最大ベット額が必要です",
  baseball_bet_limit_exists: "ベット制限はすでに存在します.",
  baseball_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  baseball_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  baseball_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  baseball_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  parlay_min_bet_required: "最低ベット額が必要です.",
  parlay_max_bet_required: "最大ベット額が必要です.",
  parlay_max_per_match_required: "試合ごとの最大ベット額が必要です",
  parlay_bet_limit_exists: "ベット制限はすでに存在します.",
  parlay_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  parlay_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  parlay_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  parlay_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  esports_min_bet_required: "最低ベット額が必要です.",
  esports_max_bet_required: "最大ベット額が必要です.",
  esports_max_per_match_required: "試合ごとの最大ベット額が必要です",
  esports_bet_limit_exists: "ベット制限はすでに存在します.",
  esports_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  esports_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  esports_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  esports_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  others_min_bet_required: "最低ベット額が必要です.",
  others_max_bet_required: "最大ベット額が必要です.",
  others_max_per_match_required: "試合ごとの最大ベット額が必要です",
  others_bet_limit_exists: "ベット制限はすでに存在します.",
  others_parent_bet_limit_not_exists: "親のベット制限設定は存在しません.",
  others_account_min_bet_lt_parent: "アカウントの最低ベット額が親の設定よりも低いです.",
  others_account_max_bet_gt_parent: "アカウントの最大ベット額が親の設定よりも高いです",
  others_account_max_per_match_gt_parent: "アカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  used_credit_gt_credit_limit: "使用済みクレジット限度額がクレジット限度額を超えています.",
  bet_limit_setting_not_exists: "ベット制限設定は存在しません.",
  parent_bet_limit_setting_not_exists: "親のベット制限設定は存在しません.",
  package_not_exists_in_parent: "親のベット制限パッケージ設定は存在しません",
  soccer_bet_limit_setting_not_exists: "サッカーのベット制限設定は存在しません.",
  soccer_update_interval_violated: "更新間隔が違反されています.",
  basketball_bet_limit_setting_not_exists: "バスケットボールのベット制限設定は存在しません.",
  basketball_update_interval_violated: "更新間隔が違反されています.",
  tennis_bet_limit_setting_not_exists:"テニスのベット制限設定は存在しません.",
  tennis_update_interval_violated: "更新間隔が違反されています.",
  baseball_bet_limit_setting_not_exists:"ベースボールのベット制限設定は存在しません.",
  baseball_update_interval_violated: "更新間隔が違反されています.",
  parlay_bet_limit_setting_not_exists:"パーレイのベット制限設定は存在しません.",
  parlay_update_interval_violated: "更新間隔が違反されています.",
  esports_bet_limit_setting_not_exists:"ESportsのベット制限設定は存在しません.",
  esports_update_interval_violated: "更新間隔が違反されています.",
  others_bet_limit_setting_not_exists:"その他のベット制限設定は存在しません.",
  others_update_interval_violated: "更新間隔が違反されています.",
  soccer_parent_bet_limit_setting_not_exists: "サッカーの親ベット制限設定は存在しません.",
  soccer_min_bet_lt_parent: "サッカーアカウントの最低ベット額が親の設定よりも低いです.",
  soccer_max_bet_gt_parent: "サッカーアカウントの最大ベット額が親の設定よりも高いです.",
  soccer_max_per_match_gt_parent: "サッカーアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  basketball_parent_bet_limit_setting_not_exists: "バスケットボールの親ベット制限設定は存在しません.",
  basketball_min_bet_lt_parent: "バスケットボールアカウントの最低ベット額が親の設定よりも低いです.",
  basketball_max_bet_gt_parent: "バスケットボールアカウントの最大ベット額が親の設定よりも高いです。.",
  basketball_max_per_match_gt_parent: "バスケットボールアカウントの試合ごとの最大ベット額が親の設定よりも高いです。.",
  tennis_parent_bet_limit_setting_not_exists: "テニスの親ベット制限設定は存在しません.",
  tennis_min_bet_lt_parent: "テニスアカウントの最低ベット額が親の設定よりも低いです.",
  tennis_max_bet_gt_parent: "テニスアカウントの最大ベット額が親の設定よりも高いです.",
  tennis_max_per_match_gt_parent: "テニスアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  baseball_parent_bet_limit_setting_not_exists: "ベースボールの親ベット制限設定は存在しません.",
  baseball_min_bet_lt_parent: "ベースボールアカウントの最低ベット額が親の設定よりも低いです.",
  baseball_max_bet_gt_parent: "ベースボールアカウントの最大ベット額が親の設定よりも高いです.",
  baseball_max_per_match_gt_parent: "ベースボールアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  parlay_parent_bet_limit_setting_not_exists: "パーレイの親ベット制限設定は存在しません.",
  parlay_min_bet_lt_parent: "パーレイアカウントの最低ベット額が親の設定よりも低いです.",
  parlay_max_bet_gt_parent: "パーレイアカウントの最大ベット額が親の設定よりも高いです.",
  parlay_max_per_match_gt_parent: "パーレイアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  esports_parent_bet_limit_setting_not_exists: "ESportsの親ベット制限設定は存在しません.",
  esports_min_bet_lt_parent: "ESportsアカウントの最低ベット額が親の設定よりも低いです.",
  esports_max_bet_gt_parent: "ESportsアカウントの試合ごとの最大ベット額が親の設定よりも高いですt.",
  esports_max_per_match_gt_parent: "ESportsアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  others_parent_bet_limit_setting_not_exists: "ESportsの親ベット制限設定は存在しません.",
  others_min_bet_lt_parent: "ESportsアカウントの最低ベット額が親の設定よりも低いです.",
  others_max_bet_gt_parent: "ESportsアカウントの最大ベット額が親の設定よりも高いです.",
  others_max_per_match_gt_parent: "ESportsアカウントの試合ごとの最大ベット額が親の設定よりも高いです.",
  update_interval_violated: "更新間隔が違反されています.",
  exceeded_parent_others: "親のその他のコミッション設定を超えています.",
  exceeded_parent_hdp: "親のHDPベット制限設定を超えています.",
  soccer_min_bet_gt_max_bet: "低ベット額は最大ベット額以下でなければなりません.",
  soccer_max_bet_gt_max_per_match: "最大ベット額は試合ごとの最大ベット額以下でなければなりません.",
  basketball_min_bet_gt_max_bet: "最低ベット額は最大ベット額以下でなければなりません.",
  basketball_max_bet_gt_max_per_match: "最大ベット額は試合ごとの最大ベット額以下でなければなりません.",
  tennis_min_bet_gt_max_bet: "最低ベット額は最大ベット額以下でなければなりません。.",
  tennis_max_bet_gt_max_per_match: "最大ベット額は試合ごとの最大ベット額以下でなければなりません.",
  baseball_min_bet_gt_max_bet: "最低ベット額は最大ベット額以下でなければなりません.",
  baseball_max_bet_gt_max_per_match: "最大ベット額は試合ごとの最大ベット額以下でなければなりません.",
  parlay_min_bet_gt_max_bet: "最低ベット額は最大ベット額以下でなければなりません.",
  parlay_max_bet_gt_max_per_match: "最大ベット額は、試合ごとの最大ベット額以下でなければなりません.",
  esports_min_bet_gt_max_bet: "最低ベット額は最大ベット額以下でなければなりません.",
  esports_max_bet_gt_max_per_match: "最大ベット額は、試合ごとの最大ベット額以下でなければなりません.",
  others_min_bet_gt_max_bet: "最低ベット額は、最大ベット額以下でなければなりません.",
  others_max_bet_gt_max_per_match: "最大ベット額は、試合ごとの最大ベット額以下でなければなりません.",

  valid: "{fname} は、少なくとも1つの大文字、1つの小文字、および1つの数字を含む必要があります（例: Abcd1234)",
  notSame: "新しいパスワードは古いパスワードと同じにできません."
};
